import { Directive, ElementRef, inject, NgZone, OnDestroy, OnInit } from '@angular/core';

import { GoogleMapComponent } from '../map/google-map.component';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'be-map-info-window',
  host: { style: 'display: none' },
})
export class MapInfoWindowDirective implements OnInit, OnDestroy {
  private readonly googleMap = inject(GoogleMapComponent);
  private readonly elementRef = inject(ElementRef);
  private readonly ngZone = inject(NgZone);

  infoWindow?: google.maps.InfoWindow;

  ngOnInit(): void {
    if (google.maps.InfoWindow) {
      this.initialize(google.maps.InfoWindow);
    } else {
      this.ngZone.runOutsideAngular(() => {
        google.maps.importLibrary('maps').then((lib) => {
          this.initialize((lib as google.maps.MapsLibrary).InfoWindow);
        });
      });
    }
  }

  ngOnDestroy(): void {
    if (this.infoWindow) {
      this.close();
    }
  }

  open(
    anchor?: google.maps.marker.AdvancedMarkerElement,
    shouldFocus?: boolean,
    content?: string,
  ): void {
    this.assertInitialized();
    this.elementRef.nativeElement.style.display = 'block';

    if (content) {
      this.infoWindow.setContent(content);
    } else {
      this.infoWindow?.setContent(this.elementRef.nativeElement);
    }

    this.infoWindow.open({
      map: this.googleMap.googleMap,
      anchor,
      shouldFocus,
    });
  }

  close(): void {
    this.assertInitialized();
    this.infoWindow.close();
  }

  private initialize(infoWindowConstructor: typeof google.maps.InfoWindow): void {
    this.ngZone.runOutsideAngular(() => {
      this.infoWindow = new infoWindowConstructor({});
    });
  }

  private assertInitialized(): asserts this is {
    infoWindow: google.maps.InfoWindow;
  } {
    if (!this.infoWindow) {
      throw new Error('InfoWindow is not initialized');
    }
  }
}
